// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table{

  box-shadow: 0px 0px 10px lightblue;
  border-radius: 10px;
}


.tableHead {
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: black;
  border-radius: 20px;
}
.tableContainer {
  /* margin-bottom: 10px; */
  margin-top: 10px;
  border-radius: 10px;
  /* border: 2px solid white; */
  border: none;
  box-shadow: 0px 0px 10px lightblue;
  overflow: auto; /* Enable vertical scrolling within the table */
  max-height: calc(100vh - 180px);  /*Adjust the max-height as needed to limit the table height */
}
.tableRow {
  height: 10px; /* Set the desired row height */
  border-radius: 10px; /* Set border-radius for rounded rectangular appearance */
  font-size: 15px; /* Set the desired font size for the table rows */
  background-color: #FFFFFF;
}
.tableRow:hover {
  background-color:#BFCFFF; /* Set the background color on hover */
  transition: background-color 0.10s ease;
  border-radius: 10px;
  transform:scale3d(1.01);
  font-weight: bold;
  font-size: 28px !important;
  top:0;
  cursor: pointer;
}

.tableRow:hover .hover-icon {
  display: inherit;
}

/* Hide the HoverIcon by default */
.tableRow .hover-icon {
  display: none;
}

/* Show the ReadMoreIcon by default */
.tableRow .readMoreIcon {
  display: block;
}

/* Hide the ReadMoreIcon when the row is hovered */
.tableRow:hover .readMoreIcon {
  display: none !important;
}

/* Style the ArrowCircleRightIcon when hovered */
.hover-icon:hover {
  transform: scale(1.1);
  color:x blue;
}

.hover-icon {

  font-size: 48px;
  cursor: pointer;
  color: rgb(170, 138, 231);
}


.MuiTableContainer-root .MuiTableHead-root {
  background-color: #6fb1d4 !important; /* Replace this with your desired blue color */
  z-index: 1;
}


.MuiTableHead-root .MuiTableCell-head {
  /* color: rgb(2, 3, 75); */
  color: #FFFFFF;
  font-weight: bold;
}


.header-container {
  /* background-color: #6fb1d4; */
  position: relative;
  z-index: 2;
  width:calc(100vw-200px);
  /* width: 1140px; */
  border-radius: 5px;
  box-shadow: 0px 0px 10px lightblue ;
  margin-top: 2px;
  margin-right: 1px;
  /* border: px solid white; */
}


/* @media only screen and (max-width:  1080px) {
  .header-container{
    display: flex;
    flex-direction: row;
  }
} */

.css-10scn0u-MuiTableCell-root{
  padding: 10px 5px !important;
  font-size: 12px !important;
  text-align: center !important; 
}

.css-nzzhz0-MuiTableCell-root{
  padding: 5px 5px !important;
  font-size: 13px !important;
  text-align: center !important;
}

.css-14ziugm-MuiTableCell-root{
  text-align: center !important;
  padding: 5px 5px !important;
  font-size: 13px !important;
}

.css-11bfvty-MuiToolbar-root-MuiTablePagination-toolbar{
  min-height: 7px !important;
}

.css-1uvddh-MuiTableCell-root {
  text-align: center !important;
  padding: 16px 7px !important;
  font-size: 13px !important; 
}`, "",{"version":3,"sources":["webpack://./src/components/Hospital/HospitalTable.css"],"names":[],"mappings":"AAAA;;EAEE,kCAAkC;EAClC,mBAAmB;AACrB;;;AAGA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;EAC7B,YAAY;EACZ,kCAAkC;EAClC,cAAc,EAAE,+CAA+C;EAC/D,+BAA+B,GAAG,6DAA6D;AACjG;AACA;EACE,YAAY,EAAE,+BAA+B;EAC7C,mBAAmB,EAAE,yDAAyD;EAC9E,eAAe,EAAE,iDAAiD;EAClE,yBAAyB;AAC3B;AACA;EACE,wBAAwB,EAAE,sCAAsC;EAChE,uCAAuC;EACvC,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,0BAA0B;EAC1B,KAAK;EACL,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,kCAAkC;AAClC;EACE,aAAa;AACf;;AAEA,qCAAqC;AACrC;EACE,cAAc;AAChB;;AAEA,kDAAkD;AAClD;EACE,wBAAwB;AAC1B;;AAEA,gDAAgD;AAChD;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;;EAEE,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;;AAGA;EACE,oCAAoC,EAAE,8CAA8C;EACpF,UAAU;AACZ;;;AAGA;EACE,0BAA0B;EAC1B,cAAc;EACd,iBAAiB;AACnB;;;AAGA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,UAAU;EACV,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,mCAAmC;EACnC,eAAe;EACf,iBAAiB;EACjB,4BAA4B;AAC9B;;;AAGA;;;;;GAKG;;AAEH;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,0BAA0B;AAC5B","sourcesContent":[".table{\n\n  box-shadow: 0px 0px 10px lightblue;\n  border-radius: 10px;\n}\n\n\n.tableHead {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  background-color: black;\n  border-radius: 20px;\n}\n.tableContainer {\n  /* margin-bottom: 10px; */\n  margin-top: 10px;\n  border-radius: 10px;\n  /* border: 2px solid white; */\n  border: none;\n  box-shadow: 0px 0px 10px lightblue;\n  overflow: auto; /* Enable vertical scrolling within the table */\n  max-height: calc(100vh - 180px);  /*Adjust the max-height as needed to limit the table height */\n}\n.tableRow {\n  height: 10px; /* Set the desired row height */\n  border-radius: 10px; /* Set border-radius for rounded rectangular appearance */\n  font-size: 15px; /* Set the desired font size for the table rows */\n  background-color: #FFFFFF;\n}\n.tableRow:hover {\n  background-color:#BFCFFF; /* Set the background color on hover */\n  transition: background-color 0.10s ease;\n  border-radius: 10px;\n  transform:scale3d(1.01);\n  font-weight: bold;\n  font-size: 28px !important;\n  top:0;\n  cursor: pointer;\n}\n\n.tableRow:hover .hover-icon {\n  display: inherit;\n}\n\n/* Hide the HoverIcon by default */\n.tableRow .hover-icon {\n  display: none;\n}\n\n/* Show the ReadMoreIcon by default */\n.tableRow .readMoreIcon {\n  display: block;\n}\n\n/* Hide the ReadMoreIcon when the row is hovered */\n.tableRow:hover .readMoreIcon {\n  display: none !important;\n}\n\n/* Style the ArrowCircleRightIcon when hovered */\n.hover-icon:hover {\n  transform: scale(1.1);\n  color:x blue;\n}\n\n.hover-icon {\n\n  font-size: 48px;\n  cursor: pointer;\n  color: rgb(170, 138, 231);\n}\n\n\n.MuiTableContainer-root .MuiTableHead-root {\n  background-color: #6fb1d4 !important; /* Replace this with your desired blue color */\n  z-index: 1;\n}\n\n\n.MuiTableHead-root .MuiTableCell-head {\n  /* color: rgb(2, 3, 75); */\n  color: #FFFFFF;\n  font-weight: bold;\n}\n\n\n.header-container {\n  /* background-color: #6fb1d4; */\n  position: relative;\n  z-index: 2;\n  width:calc(100vw-200px);\n  /* width: 1140px; */\n  border-radius: 5px;\n  box-shadow: 0px 0px 10px lightblue ;\n  margin-top: 2px;\n  margin-right: 1px;\n  /* border: px solid white; */\n}\n\n\n/* @media only screen and (max-width:  1080px) {\n  .header-container{\n    display: flex;\n    flex-direction: row;\n  }\n} */\n\n.css-10scn0u-MuiTableCell-root{\n  padding: 10px 5px !important;\n  font-size: 12px !important;\n  text-align: center !important; \n}\n\n.css-nzzhz0-MuiTableCell-root{\n  padding: 5px 5px !important;\n  font-size: 13px !important;\n  text-align: center !important;\n}\n\n.css-14ziugm-MuiTableCell-root{\n  text-align: center !important;\n  padding: 5px 5px !important;\n  font-size: 13px !important;\n}\n\n.css-11bfvty-MuiToolbar-root-MuiTablePagination-toolbar{\n  min-height: 7px !important;\n}\n\n.css-1uvddh-MuiTableCell-root {\n  text-align: center !important;\n  padding: 16px 7px !important;\n  font-size: 13px !important; \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
